import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { api } from '@/lib/api';
import { PromoOfferCard } from '@/components/PromoOfferCard';

export const PromoOffersSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get('/promo-offers?limit=4').then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="landing-promo-offers">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Ofertas</div>
          <h2 className="font-display text-2xl font-black tracking-tighter text-slate-900">Promociones</h2>
        </div>
        <Link to="/promociones" className="inline-flex items-center gap-1 text-sm font-bold text-slate-900 hover:text-orange-600" data-testid="landing-promo-offers-see-all">
          Ver todas <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((o) => <PromoOfferCard key={o.offer_id} offer={o} />)}
      </div>
    </section>
  );
};
